export enum ZbarSymbologyEnum {
  'QR' = 'QR',
  'EAN13' = 'EAN13',
  'CODE128' = 'CODE128',
}
